import { h } from 'preact';
import SVGWrapper from '../../SvgWrapper';

function BackStartIcon({ height = 60, width = 60, color = 'white' }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="m7.34077 2.45383c.19279-.13752.45937.00385.45937.24492v1.42617h4.19996c4.6805.00008 8.475 3.79449 8.475 8.47498 0 4.6806-3.7944 8.4749-8.475 8.475h-5.39996v-1.35h5.39996c3.935-.0001 7.125-3.19 7.125-7.125 0-3.93491-3.19-7.1249-7.125-7.12498h-4.19996v1.42676c-.00002.23625-.25708.37802-.45058.25019-.46233-.3054-1.19136-.7759-1.75137-1.08633-.54761-.30354-1.3048-.6604-1.82402-.89765-.22731-.10407-.23342-.43869-.00996-.55137.51976-.2621 1.28352-.65815 1.83398-.99082.55728-.33679 1.28009-.84178 1.74258-1.17187z" fill={color} />

    </SVGWrapper>

  );
}

export default BackStartIcon;
